import { FunctionComponent } from 'react';
import { SxProps, Theme, Typography, Box } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { formatNumber } from '@/features/dashboard/utils';

interface CompletedCyclesChartTitleProps {
	numberOfCompletedCycles?: number;
	percentDifference?: number;
	previousCompletedCycles?: number;
	sx?: SxProps<Theme>;
}
function getPercentColor(percent?: number) {
	if (typeof percent !== 'number') return 'inherit';
	if (percent > 0) return 'success.main';
	if (percent < 0) return 'error.main';
	return 'inherit';
}
const CompletedCyclesChartTitle: FunctionComponent<CompletedCyclesChartTitleProps> = ({
	numberOfCompletedCycles,
	percentDifference,
	previousCompletedCycles,
	sx,
}) => (
	<Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: 2, ...sx }}>
		<Typography component="span" variant="h3" sx={{ fontWeight: 700 }}>
			{formatNumber(numberOfCompletedCycles)}
		</Typography>
		{typeof percentDifference === 'number' && (
			<Typography
				component="span"
				variant="h6"
				sx={{
					color: getPercentColor(percentDifference),
					fontWeight: 700,
					display: 'flex',
					alignItems: 'center',
					gap: 0.5,
				}}
			>
				{percentDifference > 0 && <TrendingUpIcon fontSize="small" />}
				{percentDifference < 0 && <TrendingDownIcon fontSize="small" />}
				{percentDifference > 0 ? '+' : ''}
				{formatNumber(percentDifference)}%
			</Typography>
		)}
		{typeof previousCompletedCycles === 'number' && (
			<Typography component="span" variant="h6" sx={{ color: 'text.secondary', ml: 1 }}>
				{formatNumber(previousCompletedCycles)} CYCLES IN PREVIOUS PERIOD
			</Typography>
		)}
	</Box>
);

export default CompletedCyclesChartTitle;
